import React from "react";
import { Flex, Small, Icon } from "orcs-design-system";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import urlPaths, { url } from "src/consts/urlPaths";

const TagItemContainer = styled(Flex)`
  width: fit-content;
  max-width: 100%;
  justify-content: flex-start;
  align-items: center;
  padding: 5px 5px;
  margin-left: 5px !important;
  margin-right: 8px;
`;

const TagName = styled(Small)`
  font-weight: 500;
  color: #333;
  flex: 1;
  min-width: 0;
`;

const ChildIcon = styled.div`
  margin: 0 6px;
  display: flex;
  align-items: center;
`;

const ChildCount = styled(Small)`
  color: #1a237e;
  background-color: #e8eaf6;
  padding: 2px 6px;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 700;
  margin-left: 4px;
  flex-shrink: 0;
`;

const InfoIconLink = styled(Link)`
  display: flex;
  align-items: center;
  margin-left: 8px;
  color: #666;
  transition: color 0.2s ease;
  flex-shrink: 0;

  &:hover {
    color: #1976d2;
  }
`;

const TagTreeHeader = ({ node }) => {
  const childCount = node?.tag?.childTags?.total || 0;
  const hasChildren = childCount > 0;
  const linkPath = url(urlPaths.TAG_EXPLORE, { id: node.id });

  return (
    <TagItemContainer>
      <TagName>{node.name || "Unknown Tag"}</TagName>
      {hasChildren && (
        <ChildIcon>
          <Icon
            icon={["fas", "level-up"]}
            size="sm"
            transform={{ rotate: 90 }}
          />
        </ChildIcon>
      )}
      {hasChildren && <ChildCount>{childCount}</ChildCount>}
      <InfoIconLink to={linkPath}>
        <Icon icon={["far", "info-circle"]} size="sm" />
      </InfoIconLink>
    </TagItemContainer>
  );
};

TagTreeHeader.propTypes = {
  node: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    tag: PropTypes.shape({
      childTags: PropTypes.shape({
        total: PropTypes.number,
      }),
    }),
  }).isRequired,
};

export default TagTreeHeader;
